<script setup>
import ImageUploader from '@/components/ImageUploader.vue'

defineProps({
  fieldModel: Object,
  name: String,
  location: String,
  disabled: Boolean,
  maxSize: {
    type: Number,
    default() {
      return 0
    }
  }
})
</script>

<template>
  <ImageUploader
    v-model="fieldModel.inputValue"
    :name="name"
    :location="location"
    :disabled="disabled || !fieldModel.editable"
    :maxSize="maxSize"
  />
</template>
